import React from "react";

// Manuall verified at <- this doesn't made sense. (it only makes sense if the manual verification request is successful.)

const ManualVerificationTable = ({ user }) => {
  return (
    <table
      style={{
        fontSize: "14px",
        width: "100%",
      }}
      className="BOTable"
      cellPadding={0}
      cellSpacing={0}
    >
      <thead>
        {user.manual_verification_request != null ? (
          <tr>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>MV status</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Comment</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Request initiated at</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Manually verified at</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>ID number</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Error source</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Error reason</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Audit trail</b>
            </th>
          </tr>
        ) : (
          <tr></tr>
        )}
      </thead>
      {user.manual_verification_request == null ? (
        <tr>
          <td>
            There are no manual verification requests associated with this user.
          </td>
        </tr>
      ) : (
        <tbody>
          <tr>
            <td> {user.manual_verification_request.status} </td>
            <td> {user.manual_verification_request.comment} </td>
            <td> {user.manual_verification_request.created_at} </td>
            <td> {user.manual_verification_request.updated_at} </td>
            <td> {user.identity_number} </td>
            <td> {user.manual_verification_request.error_source} </td>
            <td> {user.manual_verification_request.error_reason} </td>
            <td>
              {(user.manual_verification_request.audit_trail || []).map(
                (entry, index) => (
                  <div key={index}>{entry}</div>
                )
              )}
            </td>
          </tr>
        </tbody>
      )}
    </table>
  );
};

export default ManualVerificationTable;
